import $ from 'jquery';

export default class Dropdown {
  constructor() {
    this.$dropdown = $('.dropdown');
    this.addEvents();
  }

  addEvents() {
    this.$dropdown.on('click', '.dropdown__toggle', (e) => {
      const $parent = $(e.target).closest('.dropdown');
      const isOpen = $parent.hasClass('active');

      $('.dropdown').removeClass('active');

      if (!isOpen) {
        $parent.addClass('active');
      }
    });

    this.$dropdown.on('click', '.dropdown__close', (e) => {
      const $parent = $(e.target).closest('.dropdown');
      $parent.removeClass('active');
    });
  }
}
